<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter"><em>Introduction</em></h1>
<p class="para1">Entitling a book <em>Spells and How They Work</em> may seem to be begging the question by assuming from the start that they do. So let us make our own position clear.</p>
<p class="para2">It is our experience, as practising witches for twenty years, that provided they are properly performed, with an understanding of the principles involved – yes, spells do work; if not always, then at least far more often than either coincidence or alternative explanations would allow.</p>
<p class="para2">Given this attitude, it is only sensible to ask oneself (1) why they work; (2) what are the operational principles used in making them work; (3) what code of ethics should one observe in deciding whether, and how, to perform a spell; and (4) what are the dangers involved.</p>
<p class="para2">In this book, we have tried to answer all these questions and a good many others. We have also given many examples of spells old and new.</p>
<p class="para2">But we would like to make one thing emphatically clear from the start. Observing the code of ethics (which we deal with in <a class="hlink" href="#/OEBPS/c03.htm">Chapter III</a>) is not just a matter of being virtuous and able to live with your conscience. Unethical spell-working is not only harmful to the ‘target’. It is also extremely dangerous, and in the end self-destructive, to the person who works them. Not in any hypothetical Hell, but here and now.</p>
<p class="para2">To end with a personal plea. Our earlier books have provoked a steady flood of readers’ letters which still continues by almost every post; and we take this opportunity of apologizing to those readers to whom, through sheer pressure of work, we have replied inadequately or not at all. Many of them have asked us to work spells for them. Please do not ask it this time. Trying to solve the problems of dozens of strangers whom we have never met would drain us, or anyone else, in a week. It would also be irresponsible, because, however honest the writer tries to be, one cannot have the whole picture; after all, what doctor would diagnose and prescribe by post? And if you read this book carefully, we hope you will find we have pointed a way towards solving such problems for yourself.</p>
<p class="extract">Yule, 1989</p>
<p class="right">Janet Farrar<br/> Stewart Farrar</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// int.vue?376e92e5